import api from '../api/axios';

const getAll = () => {
  return api.get('/job-overview-templates');
};

const getById = (id) => {
  return api.get(`/job-overview-templates/${id}`);
};

const create = (template) => {
  return api.post('/job-overview-templates', template);
};

const update = (id, template) => {
  return api.patch(`/job-overview-templates/${id}`, template);
};

const remove = (id) => {
  return api.delete(`/job-overview-templates/${id}`);
};

const getByCategory = (category) => {
  return api.get(`/job-overview-templates/category/${encodeURIComponent(category)}`);
};

const jobOverviewTemplateServices = {
  getAll,
  getById,
  create,
  update,
  remove,
  getByCategory,
};

export default jobOverviewTemplateServices;

